wbApp.controller('SettingsCtrl', ['$scope', 'securitySvc', 'tenantInfo', 'tenantSettingSvc',
function ($scope, securitySvc, tenantInfo, tenantSettingSvc) {

    $scope.tabs = [
    {
        title: 'TXT_MAIN',
        template: "system/settings/settings-main-tab.html"
    }];

    if (securitySvc.isInRole('MainSettings')) {
        $scope.tabs.push({
            title: 'TXT_LBL_SETTING',
            template: "system/settings/settings-settings-tab.html"
        });

        if (!tenantInfo.isFranchiseCentral) {

            $scope.tabs.push({
                title: 'TXT_LBL_ACCOUNTING',
                template: "system/settings/settings-accounting-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_NOTIFICATION',
                template: "system/settings/settings-notification-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_TERMS_AND_CONDITIONS',
                template: "system/settings/settings-terms-and-conditions-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_INSTRUCTIONS',
                template: "system/settings/settings-instructions-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_TRADE_TERMS',
                template: "system/settings/settings-trade-terms-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_PROTECTION_OF_PERSONAL_DATA',
                template: "system/settings/settings-personal-data-protection-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_HTML_CUSTOM_CONTENT',
                template: "system/settings/settings-html-custom-content-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_TEXTS',
                template: "system/settings/settings-texts-tab.html"
            });
        }
    }

    tenantSettingSvc.getAsync().$promise.then(function(ts) {
        if (ts.enableNewClientDesign && !tenantInfo.isFranchiseCentral) {
            $scope.tabs.push({
                title: 'TXT_LBL_CLIENT_SETTINGS',
                template: "system/settings/settings-client-settings-tab.html"
            });

            $scope.tabs.push({
                title: 'TXT_LBL_MOBILE_APP_SETTINGS',
                template: "system/settings/settings-mobile-app-settings-tab.html"
            });
        }
    });

    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

}]);
